import Markdown from 'react-markdown'
import Image from 'next/image'
import styles from './stats.module.scss'

import { VehicleModelContent } from '../MakeModelLanding'
import { TechnicalData, Vehicle } from '@/types/vehicle'

export type StatsProps = {
  vehicleModelContent: VehicleModelContent
  technicalData: TechnicalData[]
  vehicle: Vehicle
}

export const Stats = ({ vehicleModelContent, technicalData, vehicle }: StatsProps) => {

  const dataPoints = [
    {
      metric: 'Seconds',
      value: technicalData[12]?.displayValue ? technicalData[12].displayValue : '---',
      label: 'Acceleration from (0-62mph)',
    },
    {
      metric: 'Bph',
      value: technicalData[21]?.displayValue ? technicalData[21].displayValue : '---',
      label: 'Power up to',
    },
    {
      metric: 'Mph',
      value: technicalData[13]?.displayValue ? technicalData[13].displayValue : '---',
      label: 'Top Speed',
    },
  ]

  return (
    <section className={styles['stats-section']}>
      <div className={styles.grid}>
        <div className={styles.text}>
          <Markdown>
            {vehicleModelContent.firstBodyContent}
          </Markdown>
        </div>
      </div>
      <div className={styles.info}>
        <div className={styles.grid}>
          {vehicleModelContent.performanceSectionImage && (
            <div className={styles.image}>
              <Image
                src={vehicleModelContent.performanceSectionImage}
                alt="Performance image"
                layout="fill"
                objectFit="cover"
              />
            </div>
          )}
          <div className={styles.stats}>
            {dataPoints.map((point, index) => (
              <div key={index} className={styles.stat}>
                <div className={styles.title}>{point.label}</div>
                <div className={styles.value}>
                  <span>{point.value}</span> {point.metric}
                </div>
              </div>
            ))}
          </div>
          <div className={styles.subtitle}>The above performance data relates to the {vehicle.manufacturerName} {vehicle.modelName}.</div>
        </div>
      </div >
    </section>
  )
}
